<script setup lang="ts">
import { usePermissionsStore } from '@/stores/permissionsStore';
import { linkExternal } from '../icons/icons';
import { AppPermissionsEnum } from '@/api/generator';
import Tooltip from '../Tooltip/Tooltip.vue';

const { hasPermissions } = usePermissionsStore();

withDefaults(
  defineProps<{
    permissions?: AppPermissionsEnum[];
    tooltip?: string;
  }>(),
  {
    permissions: () => [],
    tooltip: undefined,
  },
);
</script>

<template>
  <Tooltip :disabled="!tooltip">
    <template #target="{ props }">
      <TextVBtn
        v-if="hasPermissions(permissions)"
        v-bind="{ ...props, ...$attrs }"
        :icon="linkExternal"
        color="primary"
        target="_blank"
      />
    </template>

    <template #tooltip>
      {{ tooltip }}
    </template>
  </Tooltip>
</template>

<style scoped lang="scss">
@use '@/styles/mixins';

.v-btn--icon {
  @include mixins.ml(2);
  font-size: var(v--theme);
  height: fit-content !important;
  width: fit-content !important;
  background-color: transparent !important;

  :deep(.v-btn__overlay) {
    background-color: transparent !important;
  }

  :deep(.v-icon) {
    height: 1em !important;
    width: 1em !important;
  }
}
</style>
